import ProjectButtons from "../components/ProjectButtons/ProjectButtons";

const MainPage = (props) => {
  return <ProjectButtons onEjs={props.onEjs} onGlob={props.onGlob} />;
};

export default MainPage;
